import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { domainNameValidator } from '#validation';
const addOrganizationDomainRequestSchema = z.object({
    organizationDomain: domainNameValidator({
        formatError: 'domain.format',
        requiredError: 'domain.required',
    }),
});
export class AddOrganizationDomainRequestDto extends createZodDto(addOrganizationDomainRequestSchema) {
}
